import { useQuery } from "@tanstack/react-query";
import { ManualDispatchOverviewResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { queryKeys } from "./queryKeys.ts";

export const useManualDispatchCards = () => {
  const { getToken, isAuthenticated } = useAuthentication();

  return useQuery({
    queryKey: queryKeys.manualDispatchCards(),
    queryFn: async ({ signal }): Promise<ManualDispatchOverviewResponse> => {
      const token = await getToken();
      const response = await fetch("/api/cards/manual-dispatch", {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        signal,
      });

      if (!response.ok) {
        throw new Error("Server returned status outside the 200 range.");
      }
      return ManualDispatchOverviewResponse.parse(await response.json());
    },
    enabled: isAuthenticated,
  });
};
